import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function ContactHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/contact-hero-001-1600x900.jpg"
          alt="Harambee Global Ventures contact and consultation Nairobi"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0D1F14]/75" />
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 50%)",
            backgroundSize: "20px 20px",
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 w-full pt-28 pb-20">
        <div className="max-w-3xl">
          <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-6">
              <span className="w-8 h-px bg-[#C9A961]" />
              Harambee Global Ventures &mdash; Contact Us
            </span>
          </div>

          <h1
            className={`font-['Cormorant_Garamond'] text-5xl md:text-6xl lg:text-[4.5rem] font-bold text-white leading-[1.08] mb-6 transition-all duration-700 delay-100 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            Let&apos;s Start
            <span className="block text-[#C9A961] italic">the Conversation</span>
          </h1>

          <p
            className={`text-white/75 text-lg md:text-xl leading-relaxed max-w-2xl mb-10 font-['Inter'] font-light transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            Connect with Harambee Global Ventures for financial education, advisory services, partnership opportunities, and cross-border wealth-building conversations. We are here to listen, guide, and collaborate.
          </p>

          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <a
              href="#contact-form"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md bg-[#C9A961] text-[#1A2B1F] font-semibold text-sm hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <i className="ri-arrow-right-line" />
            </a>
            <Link
              to="/advisory"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md border border-white/40 text-white font-medium text-sm hover:border-[#C9A961] hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Consultation
            </Link>
          </div>

          <div className={`mt-14 flex flex-wrap gap-8 transition-all duration-700 delay-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {[
              { icon: "ri-map-pin-2-line", label: "Nairobi, Kenya" },
              { icon: "ri-global-line", label: "Global Reach" },
              { icon: "ri-time-line", label: "2–3 Day Response" },
              { icon: "ri-lock-line", label: "Confidential" },
            ].map((badge) => (
              <div key={badge.label} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${badge.icon} text-[#C9A961] text-base`} />
                </div>
                <span className="text-white/60 text-xs uppercase tracking-wider">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-white/30" />
        <i className="ri-arrow-down-line text-white/40 text-sm" />
      </div>
    </section>
  );
}
